module.exports = ".audioMediaCategoriesCon {\n  height: 100%;\n  width: 100%;\n  color: rgb(128, 127, 131);\n  overflow: hidden;\n}\n\n.audioMediaCateHeaderCon {\n  border-bottom: 1px solid lightgray\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component.css
// module id = ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/audio/audiomedia/audiomedia.component.css
// module chunks = main